import { Transforms, Editor } from 'slate';
import isValidPoint from '@atlas/tool/box/slate/isValidPoint';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function ensureValidSelection(editor: Editor): boolean {
    const { selection } = editor;
    if (!selection) {
        return false;
    }

    const { anchor, focus } = selection;
    const isAnchorValid = isValidPoint(editor, anchor);
    const isFocusValid = isValidPoint(editor, focus);

    if (isAnchorValid && isFocusValid) {
        return true;
    }

    if (isAnchorValid && !isFocusValid) {
        Transforms.setSelection(editor, { focus: anchor });
    } else if (!isAnchorValid && isFocusValid) {
        Transforms.setSelection(editor, { anchor: focus });
    } else {
        const endPoint = Editor.end(editor, [editor.children.length - 1]);
        changeEditorSelection(editor, {
            anchor: endPoint,
            focus: endPoint,
        });
    }

    return false;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('ensureValidSelection', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
